import { render, staticRenderFns } from "./hand.vue?vue&type=template&id=829c9d66&scoped=true&"
import script from "./hand.vue?vue&type=script&lang=js&"
export * from "./hand.vue?vue&type=script&lang=js&"
import style0 from "./hand.vue?vue&type=style&index=0&id=829c9d66&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829c9d66",
  null
  
)

export default component.exports